<template>
   <Button type="dashed" :style="styleObj" class="add-button">
     <svg-icon icon-class="plus" />
     <span>{{addText}}</span>
   </Button>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: "40px"
    },
    width: {
      type: String,
      default: "100%"
    },
    addText: {
      type: String,
      default: "新增"
    }
  },
  computed: {
    styleObj() {
      return {
        height: this.height,
        width: this.width,
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.add-button {
  span {
    font-size: 14px;

    .svg-icon {
      vertical-align: -0.1em;
    }

    span {
      margin-left: 6px;
    }
  }
}
</style>
